function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M57.3998 25V27.6H55.3998H53.2998L53.1998 29.7001L52.5998 42.5C52.3998 46.7001 52.1998 50.8 51.9998 55H28.0998C27.8998 51.6 27.7998 48.3001 27.5998 44.9001C27.3998 39.8001 27.0998 34.8001 26.8998 29.7001L26.7998 27.6H24.6998H22.6998V25H57.3998ZM58.9998 22.8H20.9998C20.5998 22.8 20.2998 23.1 20.2998 23.5V29.1C20.2998 29.5001 20.5998 29.8 20.9998 29.8H24.5998C24.9998 38.7 25.4998 47.6 25.8998 56.5C25.8998 56.9001 26.1998 57.2001 26.5998 57.2001H53.4998C53.8998 57.2001 54.0998 56.9001 54.1998 56.5C54.5998 47.6 55.0998 38.7 55.4998 29.8H59.0998C59.4998 29.8 59.7998 29.5001 59.7998 29.1V23.5C59.6998 23.1 59.3998 22.8 58.9998 22.8Z",
  fill: "#BAA273"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M40 3C60.4 3 77 19.6 77 40C77 60.4 60.4 77 40 77C19.6 77 3 60.4 3 40C3 19.6 19.6 3 40 3ZM40 0C17.9 0 0 17.9 0 40C0 62.1 17.9 80 40 80C62.1 80 80 62.1 80 40C80 17.9 62.1 0 40 0Z",
  fill: "#BAA273"
});

var SvgSoilNone = function SvgSoilNone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSoilNone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/soil-none.e33e90f9.svg";
export { ForwardRef as ReactComponent };